"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatUnits;

var _util = require("@plugnet/util");

var _bn = _interopRequireDefault(require("bn.js"));

var _stripEndZero = require("../format/stripEndZero");

var _integer = _interopRequireDefault(require("../is/integer"));

// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * format a amount from unit `un` to decimals passed in.
 * @param unValue
 * @param decimals
 */
function formatUnits(unValue, decimals) {
  (0, _util.assert)((0, _integer.default)(unValue), 'not a safe integer');
  let un = new _bn.default(unValue).toString();
  un = un.padStart(decimals + 1, '0');
  const splitPos = un.length - decimals;
  const intPart = un.slice(0, splitPos);
  let fractionPart = un.slice(splitPos);
  fractionPart = (0, _stripEndZero.stripEndZero)(fractionPart);

  if (fractionPart !== '') {
    return "".concat(intPart, ".").concat(fractionPart);
  } else {
    return intPart;
  }
}